<template>
  <v-app light>
    <!--    <v-app-bar app :src="getBannerSrc()"
                   :height="100" flat>
          <template v-slot:img="{ props }">
            <v-img v-bind="props"></v-img>
          </template>
</v-app-bar>-->
    <v-content>
      <v-container v-show="showAddressInput" fluid>
        <v-row align="end">
          <v-card class="mx-auto" width="400" align="center" flat>
            <v-card-text class="title font-weight-bold" align="center">
              <div>{{ labels.deliveryAddress[language] }}</div>
              <vuetify-google-autocomplete v-model="inputAddress" ref="address" class="mt-3" id="map" autofocus flat
                outlined placeholder="請輸入地址..." v-on:placechanged="setAddressData" country="tw">
              </vuetify-google-autocomplete>
              <v-btn class="mt-2 subtitle-1 font-weight-bold" color="primary" @click="getQuotation" x-large block
                depressed :disabled="disableGetQuotation">
                {{ (this.takeOutInfo.deliveryVender === 'self') ? '確定' : '查詢運費' }}
              </v-btn>
            </v-card-text>
          </v-card>
        </v-row>
      </v-container>
      <v-container v-show="showUserInfoInput" class="primary" fluid>
        <v-card flat>
          <v-card-text class="title font-weight-bold">
            <v-row v-show="takeOutInfo.customer_address !== ''" no-gutters>
              <v-col cols="3">{{ labels.address[language] }}</v-col>
              <v-col class="primary--text" style="text-align: end">
                {{ takeOutInfo.customer_address }}
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col>{{ labels.orderAmount[language] }}</v-col>
              <v-col class="primary--text" style="text-align: end">
                ${{ orderTotalAmount }}
              </v-col>
            </v-row>
            <v-row v-show="serviceFee" no-gutters>
              <v-col>{{ labels.serviceFee[language] }}</v-col>
              <v-col class="primary--text" style="text-align: end">
                ${{ serviceFee }}
              </v-col>
            </v-row>
            <v-row v-show="takeOutInfo.customer_address !== ''" no-gutters>
              <v-col>{{ labels.deliveryPrice[language] }}</v-col>
              <v-col class="primary--text" style="text-align: end">
                ${{ takeOutInfo.deliveryPrice }}
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-divider></v-divider>
            </v-row>
            <v-row no-gutters>
              <v-col>{{ labels.total[language] }}</v-col>
              <v-col class="primary--text" style="text-align: end">
                ${{ orderTotalAmount + takeOutInfo.deliveryPrice + serviceFee }}
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-container>
      <v-container v-show="showUserInfoInput" fluid>
        <v-card class="mt-3" align="center" flat>
          <v-card-text class="display-1 font-weight-bold" align="center">
            <v-text-field label="取貨人" v-model="takeOutInfo.customer_name" class="subtitle-1 mt3" color="primary" flat
              outlined></v-text-field>
            <v-text-field label="連絡電話" v-model="takeOutInfo.customer_phone_number" class="subtitle-1" :counter="10"
              color="primary" flat type="number" outlined></v-text-field>
            <div class="d-flex align-center">
              <v-text-field label="預計取餐時間" v-model="pickUpTime" type="datetime-local" style="max-width: 360px;" dense
                outlined></v-text-field>
            </div>
            <template v-if="showInvoice">
              <p style="font-size:14px;font-weight:normal;text-align:left;line-height:1.0;">請輸入統一編號，如不需要可略過</p>
              <v-text-field label="統一編號" v-model="inputBuyerVat" class="subtitle-1" :counter="8" color="primary" flat
                type="number" outlined></v-text-field>
              <!-- <v-radio-group v-model="invoice" row>
                <v-radio label="紙本發票" :value="1"></v-radio>
                <v-radio label="線上載具" :value="2"></v-radio>
                <v-radio label="捐贈碼" :value="3"></v-radio>
              </v-radio-group> -->
              <div style="display:flex;margin:16px 0;">
                <label for="one" style="font-size:16px;">
                  <input type="radio" id="one" :value="1" v-model="invoice"><span style="padding-left:8px;">紙本發票</span>
                </label>
                <span style="width:32px;"></span>
                <label for="two" style="font-size:16px;">
                  <input type="radio" id="two" :value="2" v-model="invoice"><span style="padding-left:8px;">線上載具</span>
                </label>
                <span style="width:32px;"></span>
                <label for="three" style="font-size:16px;">
                  <input type="radio" id="three" :value="3" v-model="invoice"><span style="padding-left:8px;">捐贈碼</span>
                </label>
              </div>
              <v-text-field label="載具" v-show="invoice === 2" v-model="invoiceCarrierCode" class="subtitle-1"
                color="primary" flat type="text" outlined></v-text-field>
              <v-text-field label="捐贈碼" v-show="invoice === 3" v-model="invoiceDonateCode" class="subtitle-1"
                color="primary" flat type="text" outlined></v-text-field>
            </template>
            <v-textarea label="備註" v-model="takeOutInfo.customer_remark" class="subtitle-1" color="primary" :rows="3"
              flat outlined></v-textarea>
          </v-card-text>
        </v-card>
      </v-container>
      <v-container v-show="showError" fluid>
        <v-card class="mx-auto" width="90%" align="center" flat>
          <v-card-text class="display-1 font-weight-bold" align="center">
            <p class="display-1 primary--text">{{ errorMessage }}</p>
            <v-btn class="mt-2 subtitle-1 font-weight-bold" color="primary" @click="reset" x-large block depressed>
              重新輸入
            </v-btn>
          </v-card-text>
        </v-card>
      </v-container>
      <v-container v-show="showInProcess" fluid>
        <v-row style="height: 100pt" align="end">
          <v-card class="mx-auto" align="center" flat>
            <v-card-text class="title font-weight-bold mt-10" align="center">
              <div>作業處理中，請稍後</div>
              <br />
              <v-progress-linear indeterminate height="20" color="primary"></v-progress-linear>
            </v-card-text>
          </v-card>
        </v-row>
      </v-container>
    </v-content>
    <v-footer padless app color="white">
      <v-container fluid>
        <v-row class="pa-0">
          <v-col class="pr-0 pl-0">
            <v-btn class="subtitle-1 font-weight-bold" color="primary" @click="back" block outlined>返回上一步
            </v-btn>
          </v-col>
          <v-col class="pr-0 pl-0">
            <v-btn class="subtitle-1 font-weight-bold" color="primary" @click="setTakeOutInfo" block depressed
              :disabled="isLockSubmit">
              確定
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-footer>
  </v-app>
</template>
<script>
const moment = require('moment');
const PosTransaction = require('../modules/pos_transaction');

export default {
  name: 'DeliveryPage',
  components: {},
  props: {},
  data: () => ({
    // 新增欄位
    showInvoice: false,
    pickUpTime: '', // 外帶取餐時間
    takeoutInDays: '', // 外帶取用日
    inputBuyerVat: '', // 統一編號
    invoice: 1, // 發票或載具或捐贈碼
    invoiceCarrierCode: '', // 載具
    invoiceDonateCode: '', // 捐贈碼
    // 新增欄位
    showAddressInput: true,
    showUserInfoInput: false,
    showInProcess: false,
    showError: false,
    inputAddress: '',
    deliveryRequest: {
      dest_area: '', // 客戶所在區域
      dest_address: '', // 客戶所在地址
      expected_get_at: '', // 預計取貨時間
      expected_send_at: '', // 預計到達日期
    },
    takeOutInfo: {
      customer_name: '', // 叫件時必填
      customer_phone_number: '', // 叫件時必填
      customer_address: '',
      customer_email: '',
      customer_remark: '',
      waitTime: '',
      deliveryPrice: 0,
      originalDeliveryPrice: 0,
      contactTakeOutTime: '',
      isProcessDelivery: 'N', // 確認叫件
      deliveryVender: '', // 快遞業者
      deliveryOrderDetail: {}, // 查詢報價後之回傳資料
      orderDate: '',
    },
    diningIn: '',
    errorMessage: '',
    labels: {
      orderAmount: {
        en_US: 'ORDER',
        zh_TW: '餐點',
      },
      deliveryPrice: {
        en_US: 'DELIVERY',
        zh_TW: '運費',
      },
      total: {
        en_US: 'TOTAL',
        zh_TW: '總計',
      },
      back: {
        en_US: 'BACK',
        zh_TW: '返回上一步',
      },
      serviceFee: {
        en_US: 'Service Fee',
        zh_TW: '服務費',
      },
      address: {
        en_US: 'Address',
        zh_TW: '地址',
      },
      deliveryAddress: {
        en_US: 'Delivery Address',
        zh_TW: '外送地址',
      },
    },

  }),
  methods: {
    // 取得現在時間
    getFormattedDateTime() {
      const now = new Date();
      // 取得年、月、日
      const year = now.getFullYear();
      const month = (now.getMonth() + 1).toString().padStart(2, '0'); // 月份要 +1
      const day = now.getDate().toString().padStart(2, '0');
      // 取得時、分、秒（24 小時制）
      const hours = now.getHours().toString().padStart(2, '0');
      const minutes = now.getMinutes().toString().padStart(2, '0');
      const seconds = now.getSeconds().toString().padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    // 加上 waitTime
    getWaitTime(inputMinutes) {
      const now = new Date();
      now.setMinutes(now.getMinutes() + Number(inputMinutes));
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0'); // 月份從 0 開始，需要 +1
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const result = `${year}-${month}-${day}T${hours}:${minutes}`;
      return result;
    },
    // takeouttime
    calculateTime(inputTime) {
      // 取得當前日期
      const time = inputTime.replace('T', ' ');
      const result = `${time}:00`;
      return result;
    },
    // 檢查時間
    checkTime(inputTime, takeoutInDays) {
      const nowTime = new Date();
      const selectTime = new Date(inputTime);
      const settingTime = new Date();
      settingTime.setDate(settingTime.getDate() + Number(takeoutInDays)); // 增加指定天數
      settingTime.setHours(23, 59, 59, 999);
      if (selectTime < nowTime) {
        console.log('預計取餐時間不能早於現在時間');
        return false;
      }
      if (selectTime > settingTime) {
        const month = String(settingTime.getMonth() + 1).padStart(2, '0'); // 月份從 0 開始，需要 +1
        const day = String(settingTime.getDate()).padStart(2, '0');
        console.log(`預計取餐時間不能超過${month}月${day}日`);
        return false;
      }
      return true;
    },
    // 檢查統編
    checkBuyerVat(code) {
      const regexp = /^[0-9]{8}$/;
      return regexp.test(code);
    },
    // 檢查載具
    checkCarrierCode(code) {
      // 定義三種電子載具格式的正則表達式
      const mobileBarcodeRegex = /^[A-Z0-9.+-]{8}$/; // 手機條碼（8 碼英數字，可含 `+ . -`）
      const citizenCardRegex = /^[A-Z]{2}[0-9]{14}$/; // 自然人憑證（2 個大寫字母 + 14 碼數字）
      const companyCarrierRegex = /^\/[0-9A-Z]{7}$/; // 公司行號載具（"/" 開頭 + 7 碼英數字）
      // 只要符合任一格式，即回傳 true，否則回傳 false
      return (mobileBarcodeRegex.test(code) || citizenCardRegex.test(code) || companyCarrierRegex.test(code));
    },
    // 檢查捐贈碼
    checkDonateCode(code) {
      return /^[0-9]{3,7}$/.test(code);
    },
    getBannerSrc() {
      const setting = this.$store.getters.storeSetting;
      if (setting.kioskHomePageBanner) {
        return setting.kioskHomePageBanner.url + setting.kioskHomePageBanner.file_name;
      }
      return '';
    },
    setAddressData(addressData) {
      // console.log(addressData);
      this.deliveryRequest.dest_area = addressData.postal_code || '';
      // this.deliveryRequest.dest_area += addressData.administrative_area_level_1 || '';
      this.deliveryRequest.dest_address = addressData.name || '';
    },
    async setTakeOutInfo() {
      try {
        this.takeOutInfo.contactTakeOutTime = this.calculateTime(this.pickUpTime);
        this.$store.dispatch('setOrderContent', { takeOutInfo: this.takeOutInfo });
        // 設定統編
        if (this.inputBuyerVat.length > 0) this.$store.dispatch('setOrderContent', { invoiceBuyerVat: this.inputBuyerVat });
        if (this.invoice === 1) {
          this.goNext();
        } else {
          let type = '';
          let code = '';
          let text = '';
          // 設定載具
          if (this.invoice === 2) {
            this.$store.dispatch('setOrderContent', { invoiceCarrierCode: this.invoiceCarrierCode });
            type = 'invoiceCarrierCode';
            code = this.invoiceCarrierCode;
            text = '載具';
          }
          // 設定捐贈碼
          if (this.invoice === 3) {
            this.$store.dispatch('setOrderContent', { invoiceDonateCode: this.invoiceDonateCode });
            type = 'invoiceDonateCode';
            code = this.invoiceDonateCode;
            text = '捐贈碼';
          }
          const { token } = this.$store.getters;
          if (!token) return;
          const res = await PosTransaction.codeVerification(token, { type, code });
          if (res?.isExist === 'Y') {
            this.goNext();
          } else {
            console.log(`${text}錯誤`);
            return;
          }
        }
      } catch (error) {
        console.log('error', error);
      }
    },
    handleDialogClose() {
      this.dialogPayment = false;
    },
    goNext() {
      const next = this.$store.getters.nextStatusText;
      this.$router.push(next);
    },
    getQuotation() {
      if (this.takeOutInfo.deliveryVender !== 'self') {
        const {
          token,
          storeSetting: {
            waitTime,
            gbDeliveryPriceLimit,
            gbDeliveryPriceFree,
          },
        } = this.$store.getters;
        if (token) {
          this.showAddressInput = false;
          this.showInProcess = true;
          const _waitTime = waitTime || '30';
          const expectedGetAt = moment()
            .add(parseInt(_waitTime, 10), 'minutes');
          this.deliveryRequest.expected_get_at = expectedGetAt.format('YYYY-MM-DD HH:mm');
          this.deliveryRequest.expected_send_at = expectedGetAt.add(30, 'minutes')
            .format('YYYY-MM-DD HH:mm');
          PosTransaction.getDeliveryQuotation(token, this.deliveryRequest)
            .then((quotation) => {
              const {
                final_fee: fee,
                destinations,
              } = quotation;
              const { totalAmount } = this.$store.getters;
              if (fee < 60000 && fee < gbDeliveryPriceLimit) {
                // 超過金額免運
                this.takeOutInfo.deliveryPrice = (totalAmount > gbDeliveryPriceFree)
                  ? 0 : fee;
                this.takeOutInfo.originalDeliveryPrice = fee;
                this.takeOutInfo.customer_address = destinations;
                this.takeOutInfo.deliveryOrderDetail = quotation;
                this.showAddressInput = false;
                this.showInProcess = false;
                this.showError = false;
                this.showUserInfoInput = true;
              } else {
                if (fee >= 70000) {
                  this.errorMessage = '該地點不在服務範圍';
                } else if (fee >= 60000) {
                  this.errorMessage = '非服務時段';
                } else {
                  this.errorMessage = '運費超過上限';
                }
                this.showAddressInput = false;
                this.showInProcess = false;
                this.showUserInfoInput = false;
                this.showError = true;
              }
            })
            .catch((err) => {
              console.log('getQuotation err', err);
            });
        }
      } else {
        this.takeOutInfo.customer_address = this.inputAddress;
        this.showAddressInput = false;
        this.showInProcess = false;
        this.showError = false;
        this.showUserInfoInput = true;
      }
    },
    back() {
      this.isLockSubmit = false;
      this.$router.replace('/ORDER');
    },
    reset() {
      this.showInProcess = false;
      this.showUserInfoInput = false;
      this.showError = false;
      this.showAddressInput = true;
      this.inputAddress = '';
      this.errorMessage = '';
    },
  },
  mounted() {
    this.$store.dispatch('setStatus', 'DELIVERY');
    const { waitTime, takeoutInDays } = this.$store.getters.storeSetting;
    this.takeoutInDays = takeoutInDays;
    const { isInvoice } = this.$store.getters.store0;
    if (isInvoice === 'Y') {
      this.showInvoice = true;
    }
    this.pickUpTime = this.getWaitTime(waitTime || 0);
    this.takeOutInfo.waitTime = waitTime;
    this.takeOutInfo.orderDate = this.getFormattedDateTime();
    const { diningIn } = this.$store.getters;
    this.diningIn = diningIn;
    if (diningIn === 'for-here') {
      this.goNext();
    }
    if (diningIn === 'to-go') {
      this.showAddressInput = false;
      this.showUserInfoInput = true;
    }
    if (diningIn === 'delivery') {
      this.takeOutInfo.isProcessDelivery = 'Y';
      this.takeOutInfo.deliveryVender = this.$store.getters.deliveryVender;
    }
  },
  computed: {
    language() {
      return this.$store.getters.language;
    },
    disableGetQuotation() {
      return this.deliveryRequest.dest_area === '' || this.deliveryRequest.dest_address === '';
    },
    isLockSubmit() {
      return this.takeOutInfo.customer_name === '' || this.takeOutInfo.customer_phone_number.length !== 10
        || this.checkTime(this.pickUpTime, this.takeoutInDays) === false
        || (this.inputBuyerVat.length > 0 && this.checkBuyerVat(this.inputBuyerVat) === false)
        || (this.invoice === 2 && this.checkCarrierCode(this.invoiceCarrierCode) === false)
        || (this.invoice === 3 && this.checkDonateCode(this.invoiceDonateCode) === false);
    },
    orderTotalAmount() {
      return this.$store.getters.totalAmount;
    },
    serviceFee: {
      get() {
        const {
          diningIn,
          isTakeOutServiceFee,
        } = this.$store.getters;
        if (diningIn === 'for-here') {
          return this.$store.getters.totalServiceFee || 0;
        }
        if (diningIn === 'to-go' && isTakeOutServiceFee) {
          return this.$store.getters.totalServiceFee || 0;
        }
        return 0;
      },
    },
  },
};
</script>
<style>
.v-input input {
  letter-spacing: 0.1em !important;
}
</style>
